import {Injectable} from 'ng-metadata/core';
import {ServiceDetailsService} from '../../fullView/details/serviceDetails.service';

@Injectable()
export class MoreLikeThisItemInfoService {
        
    constructor (private serviceDetailsService: ServiceDetailsService){}
    
    public getTextFromVal(value) {
        return this.serviceDetailsService.getTextFromVal(value);
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/moreLikeThis/moreLikeThisItemInfo/moreLikeThisItemInfo.service.ts